import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { hideDialog } from '../../../redux/actions/dialogs';
import { CONFIRM_DIALOG } from '../../../redux/constants/dialogs';
import { getDialogContextValue, isDialogVisibleSelector, } from '../../../redux/selectors';

/**
 * Alerts are urgent interruptions, requiring acknowledgement, that inform the user about a situation.
 */
const ConfirmDialog = ({ visible, title, message, confirm, reject, onConfirm, onReject, hideDialog, confirmColor }) => {
  return (<Dialog
    open={visible}
    keepMounted
    onClose={hideDialog}
    aria-labelledby="alert-dialog-slide-title"
    aria-describedby="alert-dialog-slide-description"
  >
    <DialogTitle id="alert-dialog-slide-title">
      {title}
    </DialogTitle>
    { message ? <DialogContent>
      <DialogContentText id="alert-dialog-slide-description">
        {message}
      </DialogContentText>
    </DialogContent> : null }
    <DialogActions>
      <Button onClick={() => {
        if (onReject) {
          onReject()
        }
        hideDialog();
      }} color="primary">
        {reject || 'Cancel'}
      </Button>
      <Button variant="contained" onClick={() => {
        if (onConfirm) {
          onConfirm()
        }
        hideDialog();
      }} color={confirmColor||'primary'}>
        {confirm || 'Confirm'}
      </Button>
    </DialogActions>
  </Dialog>);
};

ConfirmDialog.propTypes = {
  confirm: PropTypes.string,
  reject: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func,
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
};

function mapStateToProps(state) {
  const context = getDialogContextValue(state);
  return {
    visible: isDialogVisibleSelector(state)(CONFIRM_DIALOG),
    title: context(CONFIRM_DIALOG, 'title'),
    message: context(CONFIRM_DIALOG, 'message'),
    confirm: context(CONFIRM_DIALOG, 'confirm'),
    reject: context(CONFIRM_DIALOG, 'reject'),
    onConfirm: context(CONFIRM_DIALOG, 'onConfirm'),
    onReject: context(CONFIRM_DIALOG, 'onReject'),
    confirmColor: context(CONFIRM_DIALOG, 'confirmColor'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    hideDialog: () => hideDialog(CONFIRM_DIALOG),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDialog);



// WEBPACK FOOTER //
// ./src/components/Common/ConfirmDialog/index.js